import { injectGlobal } from 'styled-components';

function init() {
  injectGlobal`

    html, body {
      margin: 0;
      padding: 0;
    }

    html {
      height: 100%;
    }

    body {
      position: relative;
      min-height: 100%;
      background-color: #1D1F35;
      font-family: 'Montserrat', sans-serif;
      padding-bottom: 80px;
    }

    ::selection {
      background: #0099ff;
      color: white;
    }
  `;
}

export default init;



// WEBPACK FOOTER //
// ./src/util/injectGlobal.js